export enum EInventoryOrderType {
    PURCHASE = 1,
    TRANSFER = 2,
}

export enum EInventoryOrderStatus {
    DRAFT = 0,
    ORDERED = 1,
    APPROVAL = 2,
    PARTIAL = 3,
    RECEIVED = 4,
    CANCELLED = 5,
}
